import React, { useEffect, useState } from "react";
import { axios, API } from "../lib/api";
import { TRUST_TIER_STYLES, LoyaltyBadge } from "./Badges";

export const TrustScoreBadge = ({ userId, compact = false }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!userId) return undefined;
    let cancelled = false;
    axios.get(`${API}/users/${userId}/trust-score`)
      .then(res => { if (!cancelled) setData(res.data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [userId]);

  if (!data) return null;
  const style = TRUST_TIER_STYLES[data.tier] || TRUST_TIER_STYLES["New Member"];

  if (compact) {
    return (
      <span
        data-testid={`trust-badge-${userId}`}
        title={`Trust Score: ${data.score}/100 • ${data.tier}`}
        className={`${style.bg} ${style.text} text-[10px] px-1.5 py-0.5 rounded-full flex items-center gap-1 font-bold border border-gray-900`}
      >
        {style.icon}
        <span>{data.score}</span>
      </span>
    );
  }

  const b = data.breakdown;
  return (
    <div
      data-testid={`trust-card-${userId}`}
      className="brutalist-card p-3 flex flex-col gap-2"
    >
      <div className="flex items-center justify-between">
        <span className={`${style.bg} ${style.text} text-xs px-2 py-1 rounded-full flex items-center gap-1 font-bold border-2 border-gray-900`}>
          {style.icon}
          <span>{data.tier}</span>
        </span>
        <span className="font-black text-xl">{data.score}<span className="text-xs text-gray-500 font-bold">/100</span></span>
      </div>
      {data.loyalty_tier && (
        <div className="flex justify-start">
          <LoyaltyBadge tier={data.loyalty_tier} />
        </div>
      )}
      <div className="grid grid-cols-2 gap-1 text-xs text-gray-700">
        <span>★ {b.rating.toFixed(1)} ({b.total_reviews} reviews)</span>
        <span>📦 {b.sold_count} sold</span>
        <span>🔄 {b.swapped_count} swaps</span>
        <span>🎁 {b.donated_count} donated</span>
      </div>
    </div>
  );
};
